<template>
  <el-dialog
    :visible.sync="newShow"
    :before-close="close"
    class="detail-dialog"
    title="更新详情"
    width="1000px">
    <div class="content">
      <div class="opt-box">
        <p class="opt">操作人:{{ row.user_realname }}</p>
        <p class="opt">操作账号:{{ row.user_name }}</p>
      </div>
      <el-table
        :data="tableData"
        border
        style="width: 100%"
      >
        <template v-for="(item,index) in propsData">

          <el-table-column
            v-if="item.attr === 'status_name'"
            :key="index"
            :prop="item.attr"
            :label="item.name"
            :width="item.columnWidth">
            <template slot-scope="scope">
              <StateBox :value="scope.row.status_name"/>
            </template>
          </el-table-column>
          <el-table-column
            v-else
            :key="index"
            :prop="item.attr"
            :label="item.name"
            :width="item.columnWidth"
          />
        </template>
      </el-table>
    </div>
  </el-dialog>
</template>

<script>
  import * as CourseListServer from "../../../../api/courseList";
  import fields from "./fields";
  import StateBox from "../StateBox.vue";

  export default {
    name: "RecordDetail",
    components: { StateBox },
    props: {
      isShow: {
        type: Boolean,
        default: false,
      },
      id: {
        type: [String, Number],
        require: true,
      },
      row: {
        type: Object,
      },
    },
    data() {
      return {
        newShow: this.isShow,
        tableData: [],
        propsData: fields,
      };
    },
    watch: {
      isShow(vl) {
        this.newShow = vl;
      },
      id(vl) {
        this.flashTable(vl);
      },
    },
    methods: {
      close() {
        this.newShow = false;
        this.$emit("update:isShow", this.newShow);
      },
      // 更新表格数据
      async flashTable(id) {
        const res = await CourseListServer.queryUpdateRecordBatchDetail({ id });
        this.tableData = res.data.map((v, i) => ({
            num: i + 1,
            course_name: v.instance && v.instance.course && (v.instance.course.name || '--'),
            status_name: v.status_text || '--',
            error_message: v.error_message || '--',
            created_at: v.created_at || '--',
          }));
      },
    },
  };
</script>

<style lang="postcss" scoped>
.content{
    position: relative;
    top: -20px;
}
.opt-box{
  display: flex;
  flex-direction: row;
  justify-items: flex-start;
  align-content: center;
}
.opt-box .opt{
  display: flex;
  flex: 1;
}
</style>
